import { selectIsLoading } from '@tokenized/sdk-js-private';
import { useTokenizedApiStateSelector } from '../../internal/redux';

/**
 * **`React hook`** Initial loading status. Show a loading screen when
 * `useIsLoading` is `true`.
 *
 * @returns Remains `true` until the Tokenized SDK has finished
 *   restoring the session on startup.
 *
 * @category Logging in and Security
 */
export function useIsLoading() {
  return useTokenizedApiStateSelector(selectIsLoading);
}
